import React from 'react';
import {LayoutChangeEvent, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {getMoreNews} from '../../../../redux/actions/news';
import {Button} from '../../../../shared/components/button';
import {Text} from '../../../../shared/components/text';
import {useStyles} from '../../../../shared/hooks/styles';
import {Filter} from '../filter';
import {blur} from '../../../../shared/utils/blur';
import {ViewProps} from './model';
import {setFilterCollapsed} from '../../../../redux/actions/runtime/news';
import {isNewsFilterCollapsedSelector} from '../../../../redux/selectors/runtime/news';
import {images} from '../../../../assets/icons';

import {contentSelector} from '../../../../redux/selectors/resources';

import {NewsItem} from './newsItem';

const filterWidthBreakpoint = 1300;

export default ({news, newsNotFound}: ViewProps) => {
  const dispatch = useDispatch();
  const isFilterCollapsed = useSelector(isNewsFilterCollapsedSelector());
  const content = useSelector(contentSelector());
  // const isDesktop = useIsDesktop();

  const styles = useStyles(({theme}) => ({
    container: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      width: '100%',
      alignSelf: 'center',
      minHeight: 225,
    },
    filters: {
      marginLeft: 30,
    },
    listContainer: {
      flexShrink: 1,
    },
    btnMore: {
      borderWidth: 0,
      alignSelf: 'center',
      width: 200,
      height: 40,
    },
    noMoreNewsText: {
      marginHorizontal: 'auto',
      marginLeft: 0,
    },
    textStyle: {
      ...theme.fonts.action,
    },
  }));

  const onMoreBtnPress = React.useCallback(() => {
    blur();
    dispatch(getMoreNews());
  }, []);

  const onLayout = React.useCallback(
    (event: LayoutChangeEvent) => {
      const filterCollapsed = event.nativeEvent.layout.width < filterWidthBreakpoint;

      if (filterCollapsed !== isFilterCollapsed) {
        dispatch(setFilterCollapsed(filterCollapsed));
      }
    },
    [isFilterCollapsed],
  );

  return (
    <View style={styles.container} onLayout={onLayout}>
      {newsNotFound && <Text style={styles.noMoreNewsText}>{content.news.noNewsInSelectedPeriod}</Text>}
      <View style={styles.listContainer}>
        {news.selection.map((newsItem) => (
          <NewsItem key={newsItem.id} newsItem={newsItem} />
        ))}
        {news.moreNewsAvailable && (
          <Button
            id='news-more'
            type='transparent'
            text='Показать еще'
            style={styles.btnMore}
            iconPosition='right'
            icon={images.ArrowDown}
            onPress={onMoreBtnPress}
          />
        )}
      </View>
      {isFilterCollapsed || <Filter style={styles.filters} />}
    </View>
  );
};
